module.exports = __webpack_public_path__ + "img/Marinichev-Stahey.113a699c.jpg";